import React from 'react';

import { Button, Dialog, Input, OverlayTrigger, PopOver, Switch } from '@tencent/spaui';

import { RPCFactory } from '../../../../utils/RequestUtil';
import copy from 'copy-to-clipboard';

class ApiSet extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      apiSettingFirst: 'none',
      apiSettingTwo: 'none',
      pushUrl: '',
      isWritePushUrl: false,
      showTip: false,
      showTipMessage: '',
      leadsGetListUrl: '',
      leadsReportUrl: '',
      reportEffectiveLeads: '',
      platformEffectiveLeads: '',
      reportLeads: 0,
      validateShow: false,
      smsCodeTypeForBtn: 1, // 短信验证码类型，1为点击获取，2为下一步
      verityCode: '',
      verityTime: 60,
      phone: '',
      showToken: false,
      secret: '',
      smsCode: '',
      showDataBack: false,
      showDataForward: false,
      showDataReturn: false,
      checked: false,
      filterImportchecked: true,
      showIcon: false,
      iconClass: '',
      modifyPushUrlErrMsg: '',
    };
  }

  componentDidMount() {
    // 获取API的配置
    RPCFactory.leadsApiManage
      .getAPiSetting(window.pageProps.uid)
      .done((data) => {
        this.setState({
          originPushUrl: data.leadsPushUrl,
          pushUrl: data.leadsPushUrl,
          leadsGetListUrl: data.leadsGetListUrl,
          leadsReportUrl: data.leadsReportUrl,
          phone: data.mobile,
          reportEffectiveLeads: data.statistics.reportEffectiveLeads,
          platformEffectiveLeads: data.statistics.platformEffectiveLeads,
          reportLeads: data.statistics.reportLeads,
          smsCodeTypeForBtn: 1,
        });
        if (data.leadsPushUrl != '') {
          this.setState({ isWritePushUrl: true });
        }
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
    RPCFactory.leadsApiManage
      .getRepeatLeads(window.pageProps.uid)
      .done((data) => {
        this.setState({ checked: data });
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
    RPCFactory.leadsApiManage
      .getFilterImportLeads(window.pageProps.uid)
      .done((data) => {
        this.setState({ filterImportchecked: data });
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
    // 临时解决tip不会自动消失的bug
    let count = 0;
    window.setInterval(() => {
      if (this.state.showTip) {
        if (count == 1) {
          this.setState({ showTip: false, showTipMessage: '' });
          count = 0;
        } else {
          count++;
        }
      }
    }, 2000);
  }

  sendToken = (codeType) => {
    if (this.state.phone != '') {
      // 发送验证码
      codeType = parseInt(codeType);
      this.setState({
        smsCodeTypeForBtn: isNaN(codeType) ? 1 : codeType,
      });
      RPCFactory.account
        .sendSMSCode(this.state.phone, 2)
        .done((data) => {
          let time = 60;
          this.setState({ validateShow: true, verityTime: time });
          this.setState({ apiSettingFirst: 'none', apiSettingTwo: 'none' });
          // 开启倒计时
          window.clearInterval(window.tt);
          window.tt = window.setInterval(() => {
            this.setState({ verityTime: time - 1 });
            time = time - 1;
            if (time <= 0) {
              this.setState({ verityTime: 0 });
              window.clearInterval(window.tt);
            }
          }, 1000);
        })
        .fail((ret, msg) => {
          alert(`请求失败，msg:${msg}`);
        });
    } else {
      this.setState({
        showTip: true,
        showTipMessage: '请在"系统设置-角色权限管理"模块进行设置独立密码和密保手机',
        iconClass: 'error',
      });
    }
  };

  onCheckedChange = (e, checked) => {
    RPCFactory.leadsApiManage
      .setRepeatLeads(window.pageProps.uid, checked)
      .done((data) => {
        const msg = checked ? '开启数据去重成功' : '关闭数据去重成功';
        this.setState({
          showTip: true,
          showTipMessage: msg,
          checked,
          iconClass: 'success',
        });
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  };

  onFilterImportCheckedChange = (e, checked) => {
    RPCFactory.leadsApiManage
      .setFilterImportLeads(window.pageProps.uid, checked)
      .done((data) => {
        const msg = checked ? '开启过滤外部导入线索成功' : '关闭过滤外部导入线索成功';
        this.setState({
          showTip: true,
          showTipMessage: msg,
          filterImportchecked: checked,
          iconClass: 'success',
        });
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  };

  copyUrl = (url, msg) => {
    if (copy(url)) {
      this.setState({ showTip: true, showTipMessage: '复制成功', iconClass: 'success' });
    } else {
      this.setState({ showTip: true, showTipMessage: '您的浏览器不支持复制，请手动复制', iconClass: 'error' });
    }
  };

  handleClose = () => {
    this.setState({ showTip: false, showTipMessage: '' });
  };

  onClose = (event) => {
    this.setState({ validateShow: false });
  };

  onCloseShowToken = (event) => {
    this.setState({ showToken: false });
  };

  veritySubmit() {
    if (this.state.smsCodeTypeForBtn) {
      RPCFactory.leadsApiManage
        .sendToken(window.pageProps.uid, this.state.phone, this.state.verityCode)
        .done((data) => {
          this.setState({
            showToken: true,
            token: data.token,
            secret: data.secret,
            validateShow: false,
          });
        })
        .fail((ret, msg) => {
          alert(`请求失败，msg:${msg}`);
        });
    }
  }

  savePushUrl = (callback) => {
    const needVerityCode = this.state.originPushUrl != this.state.pushUrl;
    RPCFactory.leadsApiManage
      .savePushUrl(
        window.pageProps.uid,
        this.state.pushUrl,
        needVerityCode ? this.state.phone : '',
        needVerityCode ? this.state.verityCode : '',
      )
      .done((data) => {
        this.setState({ showTip: true, showTipMessage: '保存数据推送地址成功', iconClass: 'success' });
        this.setState({ originPushUrl: this.state.pushUrl });
        callback && callback();
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  };

  handleVerityCodeChange = (event, val) => {
    this.setState({
      verityCode: val,
    });
  };

  render() {
    return (
      <div className="page-apiset">
        <div className="secs">
          <div className="card">
            <div className="panel">
              <div className="panel-heading">
                <i className="icon-apiset-bg"></i>
                <p className="panel-title">线索数据转发</p>
                <div className="text-tips">推送/拉取数据到您自有的CRM系统</div>
                <div className="dataclear" style={{ right: 114 }}>
                  过滤外部导入线索
                  <Switch checked={this.state.filterImportchecked} onChange={this.onFilterImportCheckedChange}></Switch>
                  {/* <OverlayTrigger trigger="hover" alignment='right' overlay={(<PopOver>该功能开启后，对接的平台将不会再接收到外部导入的线索</PopOver>)}>*/}
                  {/* </OverlayTrigger>*/}
                </div>
                <div className="dataclear">
                  线索去重
                  <OverlayTrigger
                    trigger="hover"
                    placement="top"
                    overlay={
                      <PopOver>
                        开启该按钮后，“电话重复”标签的线索将不再转发至客户自有crm系统。
                      </PopOver>
                    }
                  >
                    <i className="spaui-icon icon-help" />
                  </OverlayTrigger>
                  <Switch checked={this.state.checked} onChange={this.onCheckedChange}></Switch>
                </div>
              </div>
              <div className="panel-body">
                <div className="panel-step step-a">
                  <i className="dot"></i>
                  <label className="control-label">方法一：推送 (POST)</label>
                  <p className="step-detail">
                    通过线索管理平台将数据直接推送到您在自有CRM系统设置的接收API。
                    <a target="_blank" href="/assets/doc/api_guide.pdf">
                      接口说明
                    </a>
                    <span>  </span>
                    <a target="_blank" href="//leads.gdtimg.com/qzone/biz/gdt/leads-cdn/doc/leadspush_guide.pdf" rel="noreferrer">
                      推送操作指引
                    </a>
                  </p>
                  <button className="spaui-button spaui-button-default">
                    <a href="#/system/leadsForward/Api/interfaceSetting">接口配置</a>
                  </button>
                </div>
                <div className="panel-step step-b">
                  <i className="dot"></i>
                  <label className="control-label">方法二：拉取 (GET)</label>
                  <p className="step-detail">
                    通过下方地址，将数据从线索管理平台拉取到您自有的CRM系统。
                    <a target="_blank" href="/assets/doc/api_guide.pdf">
                      查看帮助指引
                    </a>
                  </p>
                  <p className="getapi">
                    <span className="getapi-title">数据拉取地址：</span>
                    <span className="getapi-detail-box">
                      <span className="getapi-detail">{this.state.leadsGetListUrl}</span>
                      <a
                        className="showCopyToast"
                        onClick={() => {
                          this.copyUrl(this.state.leadsGetListUrl);
                        }}
                      >
                        复制链接
                      </a>
                    </span>
                  </p>
                  <button
                    className="spaui-button spaui-button-default"
                    onClick={() => {
                      this.sendToken();
                    }}
                  >
                    <a>点击获取密钥和Token</a>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="panel">
              <div className="panel-heading">
                <i className="icon-apiset-bg-b"></i>
                <p className="panel-title">线索数据回传</p>
                <div className="text-tips">标准化处理您的线索，回传到当前线索管理平台</div>
                <div className="dataclear">
                  <a href="#/system/leadsForward/Api/leadsApiData">回传详情</a>
                </div>
              </div>
              <div className="panel-body">
                <div className="panel-step step-a">
                  <i className="dot"></i>
                  <label className="control-label">第一步: 数据标准化</label>
                  <p className="step-detail">
                    将自身CRM系统里的线索数据按以下标准处理，
                    <a target="_blank" href="/assets/doc/api_guide.pdf">
                      查看帮助指引
                    </a>
                  </p>
                  <div className="apidatas">
                    <p className="code">leads_convert_type</p>
                    <p className="status">线索状态： 无效线索、潜在客户、高意向客户、已成单</p>
                    <p className="code">leads_ineffect_reason</p>
                    <p className="status">无效原因： 非本人、定向条件外、重复数据、未接通、无意向、其它</p>
                    <p className="code">leads_intention_score</p>
                    <p className="status">线索评分： 0、0-20、20-40、40-60、60-80、80-100</p>
                  </div>
                </div>
                <div className="panel-step step-b">
                  <i className="dot"></i>
                  <label className="control-label">第二步: 回传数据</label>
                  <p className="getapi">
                    <span className="getapi-title">数据回传地址：</span>
                    <span className="getapi-detail-box">
                      <span className="getapi-detail">{this.state.leadsReportUrl}</span>
                      <a
                        className="showCopyToast"
                        onClick={() => {
                          this.copyUrl(this.state.leadsReportUrl);
                        }}
                      >
                        复制链接
                      </a>
                    </span>
                  </p>
                  <button
                    className="spaui-button spaui-button-default "
                    onClick={() => {
                      this.sendToken();
                    }}
                  >
                    <a>点击获取密钥和Token</a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Dialog
          show={this.state.validateShow}
          backdrop={true}
          enabledBackdropClose
          onClose={this.onClose}
          onSubmit={() => {
            this.veritySubmit();
          }}
          onCancel={this.onClose}
          style={{ width: '470px' }}
          title="获取密钥和Token"
          className="modal-databack"
        >
          <div className="databack-token">
            <p>
              已向密保手机{this.state.phone.substr(0, 3)}****{this.state.phone.substr(7, 11)}
              发送验证码，30分钟有效，验证通过后，
              {this.state.smsCodeTypeForBtn == 1 ? '可获取对应的密钥及token' : `可变更推送地址：${this.state.pushUrl}`}
            </p>
            <div className="tokenget">
              <Input value={this.state.verityCode} onChange={this.handleVerityCodeChange} placeholder="请输入验证码" />
              <Button
                disabled={this.state.verityTime > 0}
                onClick={() => {
                  this.sendToken();
                }}
              >
                获取验证{this.state.verityTime > 0 ? `(${this.state.verityTime})` : ''}
              </Button>
            </div>
          </div>
        </Dialog>

        <Dialog
          show={this.state.showToken}
          backdrop
          enabledBackdropClose
          title="获取秘钥和Token"
          onClose={this.onCloseShowToken}
          onSubmit={this.onCloseShowToken}
          onCancel={this.onCloseShowToken}
        >
          <div style={{ height: '200px', padding: '30px' }}>
            <div style={{ fontSize: '16px', paddingBottom: '30px' }}>您的token和secret如下，请妥善保管</div>
            <div>token：{this.state.token}</div>
            <div>secret：{this.state.secret}</div>
          </div>
        </Dialog>

        <Dialog
          show={this.state.showTip}
          timeCallback={() => this.handleClose()}
          time={2000}
          type="tip"
          modalStyle={{ zIndex: 1060 }}
          iconType={this.state.iconClass}
        >
          {this.state.showTipMessage}
        </Dialog>
      </div>
    );
  }
}

export default ApiSet;
